import { Component, OnInit } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import {AuthService} from '../core/auth.service';
import {UserModel} from '../core/model/user/userModel';
import {Helpers} from '../app.helper';

declare const $: any;

// Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    permission?: string;
}

// Menu Items - Flattened single-layer structure
export const ROUTES: RouteInfo[] = [
    {
        path: '/user/list',
        title: 'User List',
        type: 'link',
        icontype: 'people_alt',
        permission: 'user-view'
    },
    {
        path: '/agent/list',
        title: 'Agent List',
        type: 'link',
        icontype: 'people',
        permission: 'agent-view'
    },
    {
        path: '/master/listing',
        title: 'Listing',
        type: 'link',
        icontype: 'home',
        permission: 'listing-view'
    },
    {
        path: '/master/pap',
        title: 'PAP',
        type: 'link',
        icontype: 'description',
        permission: 'pap-view'
    },
    {
        path: '/master/project',
        title: 'Project',
        type: 'link',
        icontype: 'business',
        permission: 'project-view'
    },
    {
        path: '/master/agent-upload',
        title: 'Agent Upload',
        type: 'link',
        icontype: 'cloud_upload',
        permission: 'listing-view'
    },
    {
        path: '/master/agent-project-upload',
        title: 'Agent Project Upload',
        type: 'link',
        icontype: 'business_center',
        permission: 'project-view'
    }
];
@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    public menuItems: any[];
    ps: any;
    constructor(private helper: Helpers) {}

    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    }

    ngOnInit() {
        // Filter menu items based on permissions - simplified for flat menu structure
        this.menuItems = ROUTES.filter(menuItem => {
            if (menuItem.permission !== undefined) {
                return this.helper.checkAllow(menuItem.permission);
            }
            return true;
        });

        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            this.ps = new PerfectScrollbar(elemSidebar);
        }
    }
    updatePS(): void  {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            this.ps.update();
        }
    }
    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }
}
